import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import Comment from './Comment';

const Comments = ({ comments }) => (
  <>
    {
      comments.map((comment) => (
        <Box
          mt={3}
          key={comment.id}
        >
          <Comment comment={comment} />
        </Box>
      ))
    }
  </>
);

Comments.propTypes = {
  comments: PropTypes.array
};

Comments.defaultProps = {
  comments: []
};

export default Comments;
